import { FaPlus } from "react-icons/fa";
import { FiEdit3, FiPlus } from "react-icons/fi";
import { HiPlus } from "react-icons/hi";
import { LuPlus, LuTrash } from "react-icons/lu";

export const LogOperationKey = {
   CREATE: "Inserção",
   EDIT: "Edição",
   DELETE: "Exclusão",
}

export const LogOperationText = {
   [LogOperationKey.CREATE]: "Inserção",
   [LogOperationKey.DELETE]: "Exclusão",
   [LogOperationKey.EDIT]: "Edição",
}

export const LogOperationIcon = {
   [LogOperationKey.CREATE]: HiPlus,
   [LogOperationKey.DELETE]: LuTrash,
   [LogOperationKey.EDIT]: FiEdit3,
};

export const LogOperationColor = {
   [LogOperationKey.CREATE]: "var(--color-green-400)",
   [LogOperationKey.DELETE]: "var(--color-red-400)",
   [LogOperationKey.EDIT]: "var(--color-blue-400)",
};